import { subscribe } from '../../common/errors/sagas';
import { notificationError } from '../../common/errors/notificationTypes';

const pre = 'IDSUMMARYGRID/';

export const INITIALISE = `${pre}INITIALISE`;
export const SET_INITIALISED = `${pre}SET_INITIALISED`;
export const SEARCH_ID = `${pre}SEARCH_ID`;
export const SET_ROWS = `${pre}SET_ROWS`;
export const GET_IMPACT_ID_LIST_FAILED = `${pre}GET_IMPACT_ID_LIST_FAILED`;
export const GET_IMPACT_ID_LIST_EMPTY = `${pre}GET_IMPACT_ID_LIST_EMPTY`;
export const SET_LOADING = `${pre}SET_LOADING`;
export const REFRESH_DATA = `${pre}REFRESH_DATA`;
export const SET_GRID_SORTS = `${pre}SET_GRID_SORTS`;
export const SET_ALL_GRID_SORTS = `${pre}SET_ALL_GRID_SORTS`;

subscribe(GET_IMPACT_ID_LIST_FAILED, 'Failed to fetch Impact Analysis ID List', notificationError);
subscribe(GET_IMPACT_ID_LIST_EMPTY, 'Fetch Impact Analysis ID List returned an empty list', notificationError);

export const initialise = () => ({
    type: INITIALISE
});

export const setInitialised = () => ({
    type: SET_INITIALISED
});

export const searchId = id => ({
    type: SEARCH_ID,
    id
});

export const setRows = (rows, serverFilters) => ({
    type: SET_ROWS,
    rows,
    serverFilters
});

export const getImpactAnalysisIdListError = error => ({
    type: GET_IMPACT_ID_LIST_FAILED,
    error
});

export const getImpactAnalysisIdListEmpty = error => ({
    type: GET_IMPACT_ID_LIST_EMPTY,
    error
});

export const setLoading = () => ({
    type: SET_LOADING
});

export const refreshData = () => ({
    type: REFRESH_DATA
});

export const setAllGridSorts = data => ({
    type: SET_ALL_GRID_SORTS,
    data
});

export const setGridSorts = (gridId, sorting) => ({
    type: SET_GRID_SORTS,
    gridId,
    sorting
});
